function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5Z",
  fill: "#0077B5"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6283 10.8082C12.6026 9.63988 11.7671 8.75 10.4104 8.75C9.05371 8.75 8.16675 9.63988 8.16675 10.8082C8.16675 11.9524 9.0275 12.8679 10.3589 12.8679H10.3843C11.7671 12.8679 12.6283 11.9524 12.6283 10.8082ZM12.3671 14.4943H8.40122V26.4101H12.3671V14.4943ZM22.1033 14.2145C24.7131 14.2145 26.6695 15.9179 26.6695 19.5779L26.6694 26.4101H22.7037V20.0351C22.7037 18.4339 22.1298 17.3412 20.6941 17.3412C19.5985 17.3412 18.9458 18.0778 18.6592 18.7893C18.5544 19.0443 18.5286 19.3995 18.5286 19.7556V26.4104H14.5623C14.5623 26.4104 14.6145 15.6127 14.5623 14.4946H18.5286V16.1824C19.055 15.371 19.9977 14.2145 22.1033 14.2145Z",
  fill: "white"
});

var SvgLinkedIn = function SvgLinkedIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LinkedIN.8243d3df.svg";
export { ForwardRef as ReactComponent };